import { useForm } from '@tanstack/react-form'
import { UseFormOptions } from '#shared/model'
import OrderFeedbackFormValue from '../model/order-feedback-form-value'
import ValidatedOrderFeedbackFormValue from '../model/validated-order-feedback-form-value'

type OrderFeedbackFormOptions = UseFormOptions<OrderFeedbackFormValue, ValidatedOrderFeedbackFormValue>

export default function useOrderFeedbackForm({ onSubmit }: OrderFeedbackFormOptions) {
  const form = useForm<OrderFeedbackFormValue>({
    defaultValues: {
      rating: null,
      comment: '',
    },

    defaultState: {
      isValid: false,
      errorMap: {
        onMount: 'Необходимо указать рейтинг',
      },
    },

    onSubmit: async ({ value }) => {
      await onSubmit?.(value as ValidatedOrderFeedbackFormValue)
    },
  })

  return form
}
